import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const StatusGroupTransitions = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number,
				width: 50,
				showCopyButton: true
			},
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'previousGroupId',
				accessor: 'previousGroupId',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'previousGroup',
				accessor: 'previousGroup',
				filterType: FilterType.string
			},
			{
				Header: 'nextGroupId',
				accessor: 'nextGroupId',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'nextGroup',
				accessor: 'nextGroup',
				filterType: FilterType.string
			},
			{
				Header: 'previousGroupStatuses',
				accessor: 'previousGroupStatuses',
				filterType: FilterType.string
			},
			{
				Header: 'nextGroupStatuses',
				accessor: 'nextGroupStatuses',
				filterType: FilterType.string
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'createdDate', desc: true }], []);
	return (
		<div>
			<DynamicList
				columns={columns}
				id={DYNAMICLISTS.STATUS_GROUP_TRANSITIONS}
				defaultSort={defaultSort}
				fetchUrl={ADMIN.STATUS_MANAGEMENT.GET_ALLOWED_GROUP_STATUS_TRANSITION_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</div>
	);
};

export default StatusGroupTransitions;
